import React, { useEffect, useState } from "react";
import {
  EuiButton,
  EuiButtonEmpty,
  EuiFieldText,
  EuiForm,
  EuiFormRow,
  EuiModal,
  EuiModalBody,
  EuiModalFooter,
  EuiModalHeader,
  EuiModalHeaderTitle,
  useGeneratedHtmlId,
  EuiButtonIcon,
  EuiSpacer,
  EuiAvatar,
  EuiBadge,
} from "@elastic/eui";
import OrganizationService from "../../services/organization-service";

const DomainCreate = ({ props, closeModalProp }) => {
  const [domain, setDomainName] = useState("");
  const [response, setResponse] = useState("");

  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [responseColor, setResponseColor] = useState("success");

  const modalFormId = useGeneratedHtmlId({ prefix: "modalForm" });

  const closeModal = () => {
    setIsModalVisible(false);
    closeModalProp();
  };
  const showModal = () => setIsModalVisible(true);

  const createDomain = async (event) => {
    event.preventDefault();
    setLoading(true);
    const token = sessionStorage.getItem("krakenT");
    console.log(props);
    const data = {
      domainName: domain,
      organizationId: props.data.company,
    };

    OrganizationService.createMsDomainByGraph({ token, data })
      .then((response) => {
        const message =
          response.data.status === "success"
            ? "Domain created succesfully"
            : "Unexpected response format";
        setResponseColor("success");
        setLoading(false);
        setResponse(message);
      })
      .catch((error) => {
        const errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "Some error occurred";

        console.error(errorMessage);
        setResponseColor("danger");
        setLoading(false);
        setResponse(errorMessage);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const formSample = (
    <EuiForm id={modalFormId} component="form" onSubmit={createDomain}>
      <EuiFormRow label="Domain Name">
        <EuiFieldText onChange={(e) => setDomainName(e.target.value)} />
      </EuiFormRow>
    </EuiForm>
  );

  let modal;

  if (isModalVisible) {
    modal = (
      <EuiModal onClose={closeModal} initialFocus="[name=popswitch]">
        <EuiModalHeader>
          <EuiModalHeaderTitle>Create new domain</EuiModalHeaderTitle>
        </EuiModalHeader>

        <EuiModalBody>
          <EuiSpacer size="m" />
          {formSample}
          <EuiSpacer size="m" />
          {response !== "" && (
            <EuiBadge color={responseColor}>{response}</EuiBadge>
          )}
        </EuiModalBody>

        <EuiModalFooter>
          <EuiButtonEmpty onClick={closeModal}>Cancel</EuiButtonEmpty>

          <EuiButton type="submit" form={modalFormId} fill isLoading={loading}>
            Save
          </EuiButton>
        </EuiModalFooter>
      </EuiModal>
    );
  }

  return (
    <div>
      <EuiButton
        color="success"
        size="xs"
        display="base"
        iconType="plus"
        aria-label="Next"
        onClick={showModal}
      >
        Add new Domain
      </EuiButton>
      {modal}
    </div>
  );
};

export default DomainCreate;
